import { Order } from '@frontend/order/types';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

interface ViewProps {
    dispatch: ReturnType<typeof useAppDispatch>;
    account_id: string | null;
    onCancel: () => void;
    onSubmitSuccess: (order: Order) => void;
}

const useOrderCreate = (): ViewProps => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { currentAccount } = useAccountRepository();

    const onCancel = () => {
        navigate('/orders');
    };

    const onSubmitSuccess = (order: Order) => {
        navigate(`/accounts/${order.account_id}/orders/${order.id}/detail`);
    };

    return {
        dispatch,
        account_id: currentAccount,
        onCancel,
        onSubmitSuccess
    };
};

export default useOrderCreate;
